// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Vay8N","website_name":"Navbar_website_name__qr8H7","navlinks":"Navbar_navlinks__L70Jf"};